/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Open_For_WorkInputs */

const en_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`open for work`)
};

const ar_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متاح للعمل`)
};

const bn_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নতুন কাজ নিচ্ছি`)
};

const de_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`offen für Projekte`)
};

const es_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`disponible para proyectos`)
};

const fr_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`disponible pour vos projets`)
};

const pt_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`disponível para projetos`)
};

const zh_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始工作`)
};

const tr_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`işe açık`)
};

const ru_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`открыт для работы`)
};

const pl_footer_open_for_work = /** @type {(inputs: Footer_Open_For_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`otwarty do pracy`)
};

/**
* | output |
* | --- |
* | "open for work" |
*
* @param {Footer_Open_For_WorkInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_open_for_work = /** @type {((inputs?: Footer_Open_For_WorkInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Open_For_WorkInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_footer_open_for_work(inputs)
	if (locale === "bn") return bn_footer_open_for_work(inputs)
	if (locale === "de") return de_footer_open_for_work(inputs)
	if (locale === "es") return es_footer_open_for_work(inputs)
	if (locale === "fr") return fr_footer_open_for_work(inputs)
	if (locale === "pt") return pt_footer_open_for_work(inputs)
	if (locale === "zh") return zh_footer_open_for_work(inputs)
	if (locale === "tr") return tr_footer_open_for_work(inputs)
	if (locale === "ru") return ru_footer_open_for_work(inputs)
	if (locale === "pl") return pl_footer_open_for_work(inputs)
	return en_footer_open_for_work(inputs)
});